export default __webpack_public_path__ + "static/media/Kanchan_Prinsloo_AHV_In_Moms_We_Trust.f60cb0ee.jpg";